import React from 'react';
import Helmet from 'react-helmet';

export default ({
	metaTitle = 'Teddy Baldassarre',
	metaDescription = 'The Best Watch Buying Guides Delivered to Your Inbox Every Monday',
	metaKeywords = 'watches, reviews, guides',
	openGraphTitle = 'Teddy Baldassarre',
	openGraphDescription,
	openGraphImage,
	twitterTitle = 'Teddy Baldassarre',
	twitterDescription,
	twitterImage,
	twitterUsername = '@baldassarreted',
	pathname = '/',
	siteUrl = 'https://teddybaldassarre.com',
	siteName = 'Teddy Baldassarre',
}) => (
	<Helmet>
		{metaTitle && (
			<title>{metaTitle}</title>
		)}
		{metaDescription && (
			<meta
				name="description"
				content={metaDescription}
			/>
		)}
		<meta
			name="keywords"
			content={metaKeywords}
		/>
		<link rel="canonical" href={`${siteUrl}${addTrailingSlashToPathname(pathname)}`} />

		<meta
			property="og:url"
			content={`${siteUrl}${addTrailingSlashToPathname(pathname)}`}
		/>
		<meta
			property="og:title"
			content={openGraphTitle}
		/>
		<meta
			property="og:site_name"
			content={siteName}
		/>
		<meta
			property="og:description"
			content={openGraphDescription}
		/>
		{openGraphImage && (
			<meta
				property="og:image"
				content={openGraphImage.url}
			/>
		)}
		
		<meta
			name="twitter:site"
			content={twitterUsername}
		/>
		<meta
			name="twitter:card"
			content="summary_large_image"
		/>
		<meta
			name="twitter:title"
			content={twitterTitle}
		/>
		<meta
			name="twitter:description"
			content={twitterDescription}
		/>
		<meta
			name="twitter:url"
			content={`${siteUrl}${addTrailingSlashToPathname(pathname)}`}
		/>
		{twitterImage && (
			<meta
				name="twitter:image:src"
				content={twitterImage.url}
			/>
		)}
	</Helmet>
);

/**
 * Make sure that the pathname has a trailing slash. If it doesn't then we add
 * one one and if it does then we do nothing.
 * 
 * @param {string} pathname The current pathname.
 * 
 * @returns {string} Returns the pathname with a trailing slash.
 */
function addTrailingSlashToPathname(pathname) {
	if (pathname.endsWith('/')) return pathname;
	return `${pathname}/`;
}